// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `tour-summary .tour-summary {
  display: flex;
  flex-wrap: wrap;
  gap: var(--mini-spacing) var(--medium-spacing);
}
tour-summary .tour-summary svg-icon {
  margin-right: var(--small-spacing);
}
tour-summary .tour-summary p {
  margin: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}`, "",{"version":3,"sources":["webpack://./motes-sdk/src/components/tour-summary/tour-summary.component.scss"],"names":[],"mappings":"AAEI;EACI,aAAA;EACA,eAAA;EACA,8CAAA;AADR;AAGQ;EACI,kCAAA;AADZ;AAIQ;EACI,SAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AAFZ","sourcesContent":["tour-summary {\n\n    .tour-summary {\n        display: flex;\n        flex-wrap: wrap;\n        gap: var(--mini-spacing) var(--medium-spacing);\n\n        svg-icon {\n            margin-right: var(--small-spacing);\n        }\n\n        p {\n            margin: 0;\n            white-space: nowrap;\n            overflow: hidden;\n            text-overflow: ellipsis;\n        }\n    }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
